import {
  LegacyAnalyticsEventData,
  ObjectActionEventProperties,
} from '../../analytics'
import { SegmentAnalyticsCall } from '../track-event'

export function transformLegacySearchInteractionCentreSearch(
  data: Extract<
    LegacyAnalyticsEventData,
    { event: 'SearchInteraction'; eventCategory: 'centreSearch' }
  >
): SegmentAnalyticsCall {
  const eventProperties: ObjectActionEventProperties['Centre']['Searched'] = {
    category: 'Search',
    label: 'centre_searched',
    keyword: data.centreResultClicked,
  }

  return {
    method: 'track',
    parameters: ['Centre Searched', eventProperties],
  }
}
